import React from 'react'
import Title from '@boot/components/Title'
import Routes from '@boot/routes'
import GlobalStyle from '@boot/styles/global'
import Loading from '@blocks/Loading'
import useAuth from '@hooks/useAuth'
import usePageViewAnalytics from '@hooks/usePageViewAnalytics'
import ErrorBoundary from '@boot/components/ErrorBoundary'

export default function App() {
    const { user } = useAuth()

    usePageViewAnalytics()

    return (
        <React.Fragment>
            <Title />
            <GlobalStyle />
            <ErrorBoundary>
                {user !== undefined && <Routes />}
            </ErrorBoundary>
            <Loading />
        </React.Fragment>        
    )
}